import React from 'react';

const SupportTitle = ({title}) => {
  return (
    <div
      style={{
        textTransform: 'uppercase',
        fontSize: '20',
        color: '#45c945',
        fontWeight: 'bold',
        textAlign: 'center',
      }}>
      {title}
    </div>
  );
};

export default SupportTitle;



// WEBPACK FOOTER //
// ./src/pages/Support/components/title/index.js